import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato tras tu compra. Recibirás un correo electrónico con los enlaces para descargar todo el material digital (PDFs) en tu dispositivo.'
  }, {
    q: '¿Para qué edades sirve?',
    a: 'El pack cubre desde 1° grado de primaria hasta 6° año de secundaria, adaptando los contenidos y la complejidad a cada etapa del desarrollo.'
  }, {
    q: '¿Se puede imprimir?',
    a: '¡Sí! Todos los tomos y bonos están en formato PDF de alta calidad, listos para imprimir o para usar digitalmente en clase.'
  }, {
    q: '¿Los bonos están incluidos en los $19 USD?',
    a: 'Sí, los 5 bonos exclusivos están incluidos de forma 100% gratuita con tu compra de hoy por $19 USD.'
  }, {
    q: '¿Tengo que pagar una mensualidad?',
    a: 'No. Es un pago único de $19 USD y tienes acceso de por vida a todo el material y sus futuras actualizaciones.'
  }, {
    q: '¿Cuáles son las formas de pago?',
    a: 'Aceptamos tarjetas de crédito, débito y PayPal. El pago se procesa de forma 100% segura.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-white" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-12" data-id="element-43">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, i) => <div key={i} className="bg-[#fdfaf6] rounded-2xl overflow-hidden border border-brand-creamDark/50" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-46">
                <span className="font-bold text-brand-text pr-4" data-id="element-47">{faq.q}</span>
                <div className="shrink-0 text-brand-red" data-id="element-48">
                  {openIndex === i ? <X className="w-5 h-5" data-id="element-49" /> : <Plus className="w-5 h-5" data-id="element-50" />}
                </div>
              </button>
              <AnimatePresence data-id="element-51">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                    <div className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-53">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}